import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import {
  AnnouncementList,
  AnnouncementModal,
  AnnouncementFilter,
  AnnouncementDetails,
  AnnouncementFilterList,
  AnnouncementListingQueryParameters,
  AnnouncementFilterListingQueryParameters,
} from "./type";

const initialState: AnnouncementModal = {
  announcementList: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },

  announcementListingQueryParameters: {
    pageNo: 1,
    limit: 10,
  },

  announcementFilter: {
    manufacturerId: "",
    announcementType: "",
  },

  announcementDetails: {
    _id: "",
    image: "",
    subject: "",
    addedById: "",
    isRead: false,
    sentData: null,
    description: "",
    companyName: "",
    manufacturerName: "",
    announcementType: "",
  },

  announcementFilterList: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },

  announcementFilterListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchKey: "",
  },

  isUnreadAnnouncement: false,
};

const AnnouncementSlice = createSlice({
  name: "announcement-management",
  initialState,
  reducers: {
    setIsUnreadAnnouncement: (
      state: AnnouncementModal,
      action: PayloadAction<boolean>,
    ) => {
      state.isUnreadAnnouncement = action.payload;
    },

    setAnnouncementListingData: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementList>,
    ) => {
      if (action.payload.data && action.payload.data.length === 0) {
        state.announcementList.data = [...action.payload.data];
      } else {
        state.announcementList.data = [
          ...state.announcementList.data,
          ...action.payload.data,
        ];
      }
      state.announcementList.total = action.payload.total;
      state.announcementList.pageNo = action.payload.pageNo;
      state.announcementList.totalPage = action.payload.totalPage;
      state.announcementList.nextHit = action.payload.nextHit;
      state.announcementList.limit = action.payload.limit;
    },

    setAnnouncementFilteredListingData: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementList>,
    ) => {
      state.announcementList = action.payload;
    },

    setAnnouncementListingQueryParameters: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementListingQueryParameters>,
    ) => {
      state.announcementListingQueryParameters = action.payload;
    },

    setAnnouncementFilter: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementFilter>,
    ) => {
      state.announcementFilter = action.payload;
    },

    setAnnouncementDetails: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementDetails>,
    ) => {
      state.announcementDetails = action.payload;
    },

    setAnnouncementFilterListingData: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementFilterList>,
    ) => {
      if (action.payload.data && action.payload.data.length === 0) {
        state.announcementFilterList.data = [...action.payload.data];
      } else {
        state.announcementFilterList.data = [
          ...state.announcementFilterList.data,
          ...action.payload.data,
        ];
      }
      state.announcementFilterList.total = action.payload.total;
      state.announcementFilterList.pageNo = action.payload.pageNo;
      state.announcementFilterList.totalPage = action.payload.totalPage;
      state.announcementFilterList.nextHit = action.payload.nextHit;
      state.announcementFilterList.limit = action.payload.limit;
    },

    setAnnouncementFilterListingQueryParameters: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementFilterListingQueryParameters>,
    ) => {
      state.announcementFilterListingQueryParameters = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setAnnouncementFilter,
  setAnnouncementDetails,
  setIsUnreadAnnouncement,
  setAnnouncementListingData,
  setAnnouncementFilterListingData,
  setAnnouncementFilteredListingData,
  setAnnouncementListingQueryParameters,
  setAnnouncementFilterListingQueryParameters,
} = AnnouncementSlice.actions;

export default AnnouncementSlice.reducer;
